export const CARD_WIDTH = 87.5; //mm (ISO CR80)
export const CARD_HEIGHT = 56; //mm (ISO CR80)
export const CARD_CORNER_RADIUS = 3.18; //mm (ISO CR80)

export const CARD_RATIO = CARD_HEIGHT / CARD_WIDTH;

export const DEFAULT_MAX_LOGO_WIDTH = 33; //mm
export const DEFAULT_MAX_LOGO_HEIGHT = 11; //mm
export const CARD_FRONT_PADDING = 6; //mm
export const CARD_BACK_PADDING = 6; //mm
export const DETAILS_DISTANCE_FROM_BOTTOM = 11; //mm (12mm is actually the end of the curve but 11 is more visually correct)
export const BLINQ_LOGO_MARGIN_RIGHT = 1.5; // mm

export const BLINQ_LOGO_HEIGHT = 18;
export const BLINQ_LOGO_WIDTH = 6;
export const BLINQ_TEXT_WIDTH = 28.5; // Measured using getBBox() - this shouldn't change unless we change the font size
export const BLINQ_TEXT_HEIGHT = 16.34; // Measured using getBBox() - this shouldn't change unless we change the font size

export const ESSENTIAL_BLINQ_LOGO_HEIGHT_EXTRA_LARGE = 40; // Used for the huge logo on the front of the Essential cards
export const ESSENTIAL_BLINQ_LOGO_WIDTH_EXTRA_LARGE = 13.333; // Used for the huge logo on the front of the Essential cards
export const ESSENTIAL_BLINQ_LOGO_EXTRA_LARGE_MARGIN_RIGHT = 9;

// Display specific constants
export const ESSENTIAL_BLINQ_TEXT_WIDTH_DISPLAY = 61.68; // Measured using getBBox() - this shouldn't change unless we change the font size
export const ESSENTIAL_BLINQ_TEXT_HEIGHT_DISPLAY = 33.81; // Measured using getBBox() - this shouldn't change unless we change the font size

export const DEFAULT_SVG_DX_DISPLAY = 277; // different between print and display
export const DEFAULT_SVG_DY_DISPLAY = DEFAULT_SVG_DX_DISPLAY * CARD_RATIO;

export const QR_CODE_SIZE_DISPLAY = 16; //mm - different between print and display
export const QR_CODE_RADIUS_DISPLAY = 4;
export const ESSENTIAL_BLINQ_LOGO_MARGIN_RIGHT_DISPLAY = 5; // Some extra padding for the logo icon

// Print specific exports
// The production rasteriser (gcp-functions) uses Puppeteer with deviceScaleFactor: 2,
// so the SVG dimensions are halved to produce the target output of 2114 × 1370.
export const DEFAULT_SVG_WIDTH_PRINT = 1057; // px — 2114 / 2 (deviceScaleFactor)
export const DEFAULT_SVG_HEIGHT_PRINT = 685; // px — 1370 / 2 (deviceScaleFactor)

// ViewBox dimensions must match the output pixel aspect ratio (2114 × 1370).
// Scaled down by 8× to keep viewBox coordinates in a manageable range.
export const SVG_VIEWBOX_WIDTH_PRINT = DEFAULT_SVG_WIDTH_PRINT / 8; // 264.25
export const SVG_VIEWBOX_HEIGHT_PRINT = DEFAULT_SVG_HEIGHT_PRINT / 8; // 171.25
export const ESSENTIAL_BLINQ_TEXT_WIDTH_PRINT = 55.11; // Measured using getBBox() - this shouldn't change unless we change the font size
export const ESSENTIAL_BLINQ_TEXT_HEIGHT_PRINT = 32.2; // Measured using getBBox() - this shouldn't change unless we change the font size
export const QR_CODE_PADDING_PRINT = 1.3;
export const QR_CODE_SIZE_PRINT = 15; //mm - different between print and display
export const QR_CODE_RADIUS_PRINT = 2;
export const QR_CODE_INNER_RADIUS_PRINT = 1.2;
